module.exports = __webpack_public_path__ + "static/media/gamehive-logo.9199f5cc.png";